import axios from 'axios';

const s3Upload = async (item, file, onProgress) => {
  var fd = new FormData();
  for (var key in item.s3) {
    fd.append(key, item.s3[key]);
  }

  if(typeof(file) === "string") {
    const blob = dataURIToFil(file, item.file_ext);
    fd.append('file', new File([blob], item.name));
  } else {
    fd.append('file', file);
  }

  return await axios.post(item.url, fd, {
    crossDomain: true,
    processData: false,
    contentType: false,
    responseType: 'text',
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (progressEvent) => {
      onProgress ? onProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total)) : null;
    }
  });
}

const dataURIToFil = (dataURI, ext) => {
  const binary = atob(dataURI.split(',')[1]);
  const array = [];
  const types = { jpg: 'image/jpeg', png: 'image/png' }
  for(let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], { type: types[ext] || 'image/jpeg' });
}

export { s3Upload };
